import React, { useMemo } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import HighchartsExporting from "highcharts/modules/exporting";
import HighchartsAccessibility from "highcharts/modules/accessibility";
import { useTheme } from "@mui/material/styles";
import { useGetAllPurDhashStoreProductQuery } from "../../../Api/attoDeskApi";
import { CircularProgress } from "@mui/material";

interface StoreItemCount {
  storeName: string;
  item_count: number;
}

HighchartsExporting(Highcharts);
HighchartsAccessibility(Highcharts);

const PayrollDashboard = () => {
  const theme = useTheme();

  const { data, isLoading } = useGetAllPurDhashStoreProductQuery({ id: "" });

  const chartData: StoreItemCount[] = Array.isArray(data?.data)
    ? data?.data ?? []
    : [];

  const categories = useMemo<string[]>(
    () => chartData.map((item) => item.storeName),
    [chartData]
  );

  const seriesData = useMemo<number[]>(
    () => chartData.map((item) => Number(item.item_count)),
    [chartData]
  );
  const barChartOptions: Highcharts.Options = useMemo(
    () => ({
      chart: {
        type: "column",
        backgroundColor: theme.palette.cardAdd?.bgColor || "#fff",
      },

      title: { text: undefined },

      xAxis: {
        categories,
        title: {
          text: "Store",
          style: {
            color: theme.palette.heading?.headingColor || "#000",
            fontSize: "0.75rem",
          },
        },
        labels: {
          style: {
            color: theme.palette.heading?.headingColor || "#000",
            fontSize: "0.75rem",
          },
        },
      },

      yAxis: {
        min: 0,
        title: {
          text: "Number of Items",
          style: {
            color: theme.palette.heading?.headingColor || "#000",
            fontSize: "0.75rem",
          },
        },
      },

      tooltip: {
        pointFormat: "<b>{point.y}</b> Items",
      },

      plotOptions: {
        column: {
          dataLabels: {
            enabled: true,
          },
        },
      },

      legend: { enabled: false },

      series: [
        {
          type: "column",
          name: "Items",
          data: seriesData,
          color: theme.palette.primary.main,
        },
      ],

      credits: { enabled: false },
    }),
    [categories, seriesData, theme]
  );

  return (
    <div style={{ padding: "5px" }}>
      {isLoading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "300px",
          }}
        >
          <CircularProgress />
        </div>
      ) : (
        <HighchartsReact highcharts={Highcharts} options={barChartOptions} />
      )}
    </div>
  );
};

export default PayrollDashboard;
